import { render } from "./FormCheckboxList.vue?vue&type=template&id=edddd30e"
import script from "./FormCheckboxList.vue?vue&type=script&lang=js"
export * from "./FormCheckboxList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__